import { proxy } from "valtio";
import { devtools } from "valtio/utils";

export const proposal = proxy({
  proposalCountry: "",
  proposalApproved: false,
  buildingName: "",
  importBuildingName: "",
  hideIntroduction: false,
  hide12months: false,
  separatePrinter: false,
  unitPrice: 0,
  rideRacksPrice: 0,
  shipmentPrice: 0,
  installationPricing: 0,
  tuluPay: 0,
  subscriptionFee: 0,
  totalRetailCost: 0,
  setupFeeBeforeDiscount: 0,
  setupFee: 0,
  ownerRevenue: 50,
  editors: [],
});

export const appState = proxy({
  email: null,
  sideBarOpen: false,
  pdfRenders: 0,
  uploadStatus: "",
});
devtools(proposal, { name: "proposal details" });
devtools(appState, { name: "app state" });
